import Divider from "components/Divider/Divider";
import TextMAS from "components/TextMAS/TextMAS";
import React from "react";
import TransactionDetailCard from "../transaction-detail-card/TransactionDetailCard";
import s from "./TransactionDetailSection.module.scss";
import { useTranslation } from "react-i18next";
import { Stack } from "@mui/material";

const TransactionDetailSection = ({
  offline,
  online,
  transactions,
  payment,
  openSendReceiptDialog,
  openVoidTransactionDialog,
  openRefundTransactionDialog,
}) => {
  const isOffline = offline || !online;
  const ENV_LOCALE_KEY = isOffline ? "offline" : "online";
  const COMPONENT_LOCALE_KEY = `page.transactions.sharedComponents.transactionDetailsSection.${ENV_LOCALE_KEY}.`;

  const { t } = useTranslation();

  return (
    <div className={s["transaction-list"]}>
      <div className={s["header"]}>
        <TextMAS fontSize="24px" fontWeight="medium" color="brandDark64">
          {t(COMPONENT_LOCALE_KEY + "title")}
        </TextMAS>
      </div>
      <Divider />
      <div className={s["content-container"]}>
        {!(transactions instanceof Array) || transactions.length === 0 ? (
          <Stack direction="row" justifyContent="center">
            <TextMAS fontSize="large">
              {t(COMPONENT_LOCALE_KEY + "noRecord")}
            </TextMAS>
          </Stack>
        ) : (
          transactions.map((transaction, index) => {
            return (
              <div key={index} className={s["card-container"]}>
                <TransactionDetailCard
                  offline={offline}
                  online={online}
                  key={index}
                  transaction={transaction}
                  payment={payment}
                  transactions={transactions}
                  openSendReceiptDialog={openSendReceiptDialog}
                  openVoidTransactionDialog={openVoidTransactionDialog}
                  openRefundTransactionDialog={openRefundTransactionDialog}
                />
              </div>
            );
          })
        )}
      </div>
    </div>
  );
};

export default TransactionDetailSection;
